module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/inventory.component.html
// module id = 1250
// module chunks = 0